export const calculateStake = (
  stakePerLine: number,
  numberOfLines: number,
  eachWaySelected?: boolean
): number =>
  stakePerLine * numberOfLines * 100 + (eachWaySelected ? stakePerLine * numberOfLines * 100 : 0);
